<template>
    <a-drawer title="心理师签约" width="500" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="心理师" prop="cid">
                <a-select v-model="field.cid" show-search :filter-option="false" @search="doQueryCta" placeholder="请选择心理师">
                    <template v-for="cta in ctas">
                        <a-select-option :value="cta.id" :key="cta.id" :disabled="cta.sign">[{{ cta.id }}] {{ cta.name }}</a-select-option>
                    </template>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="签约主题" prop="rsub">
                <a-input v-model="field.rsub" placeholder="请填写聘用主题" />
            </a-form-model-item>
            <a-form-model-item label="证书模板" prop="tid">
                <a-select v-model="field.tid" placeholder="请选择签约证书模板">
                    <template v-for="cert in certs">
                        <a-select-option :value="cert.id" :key="cert.id">
                            {{ cert.name }}
                        </a-select-option>
                    </template>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="签约开始日期" prop="start">
                <a-date-picker v-model="field.start" placeholder="请选择签约日期" value-format="YYYY-MM-DD" />
            </a-form-model-item>
            <a-form-model-item label="签约截至日期" prop="end">
                <a-date-picker v-model="field.end" placeholder="请选择截至日期" value-format="YYYY-MM-DD" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    确认签约
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            ctas: [],
            fetching: false,
            certs: [],
            field: {
                cid: '',
                tid: '',
                start: '',
                end: '',
                rsub: ''
            },
            rules: {
                cid: [{ required: true, message: '请选择心理师', trigger: 'change' }],
                tid: [{ required: true, message: '请选择签约证书模板', trigger: 'change' }],
                rsub: [{ required: true, message: '请填写签约主题', trigger: 'blur' }],
                start: [{ required: true, message: '请选择签约开始日期', trigger: 'change' }],
                end: [{ required: true, message: '请选择签约截至日期', trigger: 'change' }]
            }
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.doLoadCertTmpl()
            this.doQueryCta('')
        },
        doLoadCertTmpl() {
            this.$http
                .get('/sys/data/crs/cert/tmpl', {
                    params: {
                        size: 10,
                        type: 'CT07'
                    },
                    loading: {
                        flag: false
                    }
                })
                .then(result => {
                    this.certs = result.datas
                })
        },
        doQueryCta(key) {
            this.fetching = true
            this.$http
                .get('/sys/data/user/cta', {
                    params: {
                        size: 10,
                        name: key
                    },
                    loading: {
                        flag: false
                    }
                })
                .then(result => {
                    this.ctas = result.datas
                    this.fetching = false
                })
        },
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/ums/unit/cta/sign', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('签约成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        }
    }
}
</script>
